<template>
  <textarea :disabled="true" rows="10" class="text-n-gray-dark">
We as community members and event hosts recognize that, around the world, the circumstances and causes of death are inordinately influenced by race, gender, class, sexuality, faith, ability, and/or other aspects of our identity, which should not determine the dignity and duration of our lives.

We recognize that it is not possible to reach the true depth of conversations about how to live fully from now through the end without acknowledging these factors.

As Reimagine community members, we agree to utilize the best of our knowledge, courage, vulnerability, and resources available to cultivate spaces that are inclusive.

As Reimagine community members, we agree to create spaces that are intentional and considerate of the diverse needs of different people.

As Reimagine community members, we agree to create spaces that are equitable - striving to ensure everyone has what they need, recognizing that those who have more can give more, and those who need more support can get more support.

We recognize that whether or not we are “experts” in a field, our humility, curiosity, and will to grow can be an integral part of creating a space that can hold all of what life and death have to show us.
  </textarea>
</template>

<script>
export default {
  name: "JediCommunityPledge"
}
</script>

<style scoped>

</style>